import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=569f0fc2&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('569f0fc2')) {
      api.createRecord('569f0fc2', component.options)
    } else {
      api.reload('569f0fc2', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=569f0fc2&", function () {
      api.rerender('569f0fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrations/Index.vue"
export default component.exports